export default __webpack_public_path__ + "static/media/dashboard_help.c7aa1dd3.jpeg";